import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton, SpecraEmptyState, SpecraLink } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { ConvertToProposalDialog } from '../../../../components/Capture/ConvertToProposalDialog';
import { LifecycleNodeKind, linkedNodesQueryKey } from '../../../../components/LinkedChips';
import { proposalHref } from '../../../../lib/proposalHref';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { usePursuitRecord } from '../PursuitRecordContext';
import { PursuitSectionFrame } from '../PursuitSectionFrame';
import { useCaptureProposalLinks } from '../pursuitHooks';
/** Proposal: proposals opened from this pursuit (links via proposalHref) and the convert action. */ export function ProposalSection() {
    const { captureProjectId, capabilities } = usePursuitRecord();
    const { proposals } = useCaptureProposalLinks(captureProjectId);
    const [convertOpen, setConvertOpen] = useState(false);
    const cache = useQueryClient();
    // As on today's page: refresh the linked records when the dialog closes.
    useEffect(()=>{
        if (!convertOpen) void cache.invalidateQueries({
            queryKey: linkedNodesQueryKey(LifecycleNodeKind.PURSUIT, captureProjectId)
        });
    }, [
        convertOpen,
        cache,
        captureProjectId
    ]);
    return /*#__PURE__*/ _jsxs(PursuitSectionFrame, {
        actions: capabilities.canEdit && capabilities.canConvertToProposal ? /*#__PURE__*/ _jsx(SpecraButton, {
            "data-testid": Testids.capture.convertButton,
            onClick: ()=>setConvertOpen(true),
            variant: "secondary",
            children: "Open Proposal"
        }) : undefined,
        title: "Proposal",
        children: [
            proposals.length === 0 ? /*#__PURE__*/ _jsx(SpecraEmptyState, {
                description: "Open a proposal from this pursuit when you decide to bid.",
                framed: true,
                title: "No proposal yet"
            }) : /*#__PURE__*/ _jsx("ul", {
                className: "space-y-[var(--space-2)]",
                children: proposals.map((p)=>/*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx(SpecraLink, {
                            href: proposalHref(p.zouProjectId, 'home'),
                            renderLink: renderRouterLink,
                            children: p.label
                        })
                    }, p.id))
            }),
            /*#__PURE__*/ _jsx(ConvertToProposalDialog, {
                captureProjectId: captureProjectId,
                onOpenChange: setConvertOpen,
                open: convertOpen
            })
        ]
    });
}
